import { BrowserDetectionService } from '../../services/browser-detection';
import { StringService } from '../../services/string';
import { maskAssetUrl } from '../mask-asset-url';
import { AssetData } from './types';

// TODO: Change to automatic WebP support from Storyblok image service.
const getEncodeFormat = (): string =>
  BrowserDetectionService.isWebPSupported() === false ? '' : 'filters:format(webp):quality(90)/';
const convertToStoryblokImageService = (url: string): string => `${maskAssetUrl(url)}/m/$0x$1/${getEncodeFormat()}`;

export const parseAssetSource = (filename: string): string => {
  if (typeof filename !== 'string' || StringService.isVideoUrl(filename)) {
    return filename;
  }

  return StringService.isImageUrl(filename) ? convertToStoryblokImageService(filename) : maskAssetUrl(filename);
};

export const parseDownloadSource = (filename: string): string => {
  if (typeof filename !== 'string' || StringService.isVideoUrl(filename)) {
    return filename;
  }

  return maskAssetUrl(filename);
};

export const asset = (key: string, data: AssetData): Record<string, string> => ({
  [key]: JSON.stringify({
    src: parseAssetSource(data.filename),
    caption: data.title,
    copyright: data.copyright,
    alt: data.alt,
  }),
});
